import { Component } from '@angular/core';

/**
 * Header region of `upp-panel`. Projects arbitrary content (typically `upp-header`).
 */
@Component({
    selector: 'upp-panel-header',
    templateUrl: './upp-header.html',
    styleUrls: ['./upp-header.scss'],
})
export class UppPanelHeaderComponent {
    // nothing to do
}
